/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_speed_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do ships and planes use knots instead of mph or km/h?`)
};

const es_uc_speed_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué los barcos y aviones usan nudos en lugar de mph o km/h?`)
};

const de_uc_speed_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum verwenden Schiffe und Flugzeuge Knoten statt mph oder km/h?`)
};

const nl_uc_speed_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom gebruiken schepen en vliegtuigen knopen in plaats van mph of km/u?`)
};

const fr_uc_speed_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les navires et avions utilisent-ils des nœuds au lieu de mph ou km/h ?`)
};

const it_uc_speed_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché navi e aerei usano i nodi anziché mph o km/h?`)
};

const pt_br2_uc_speed_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que navios e aviões usam nós em vez de mph ou km/h?`)
};

const pt_uc_speed_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que navios e aviões utilizam nós em vez de mph ou km/h?`)
};

const ja_uc_speed_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`船と飛行機が mph や km/h の代わりにノットを使う理由は何ですか?`)
};

const zh_uc_speed_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_speed_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_speed_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_speed_faq2_q", locale)
	if (locale === "en") return en_uc_speed_faq2_q(inputs)
	if (locale === "es") return es_uc_speed_faq2_q(inputs)
	if (locale === "de") return de_uc_speed_faq2_q(inputs)
	if (locale === "nl") return nl_uc_speed_faq2_q(inputs)
	if (locale === "fr") return fr_uc_speed_faq2_q(inputs)
	if (locale === "it") return it_uc_speed_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_speed_faq2_q(inputs)
	if (locale === "pt") return pt_uc_speed_faq2_q(inputs)
	if (locale === "ja") return ja_uc_speed_faq2_q(inputs)
	return zh_uc_speed_faq2_q(inputs)
};